/*@ngInject*/
module.exports = function(publicObjectsService, publicServicesService) {
	return {
		scope: {
			viewMode: '=',
			type: '@',
			filter: '='
		},
        restrict: 'E',
		bindToController: true,
		controllerAs: 'vm',
		controller: function() {
			let vm = this;
			vm.searchResultObjects = [];

            vm.runAutocompleteSearch = _.debounce(function() {
                if (vm.search_word && vm.search_word.length >= 3) {
                    vm.searchLoading = true;
                    if (vm.type === 'objects') {
                        publicObjectsService.getObjectsBySearch(vm.filter, vm.search_word).then(function (result) {
                            vm.searchResultObjects = result.data;
                            vm.searchLoading = false;
                        });
                    }
                    if (vm.type === 'services') {
                        publicServicesService.getServicesBySearch(vm.filter, vm.search_word).then(function (result) {
                            vm.searchResultObjects = result.data;
                            vm.searchLoading = false;
                        });
                    }
                } else {
                    vm.searchResultObjects = [];
                }
            }, 500, {
                'leading': false,
                'trailing': true
            });
            vm.close = () => {
                document.getElementById('searchInput').focus();
            };
		},
		template: require('./autocomplete.directive.html')
	};
};



/** WEBPACK FOOTER **
 ** ./app/shared/directives/autocomplete.directive.js
 **/